import { apiService } from "./api";

export const efaxService = {
  // Upload and process eFax
  uploadEFax: async (formData) => {
    try {
      const response = await apiService.post("/efax/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 180000, // 3 minutes timeout
      });
      return response.data;
    } catch (error) {
      console.error("Error uploading eFax:", error);
      throw error;
    }
  },

  // Get processed eFax information
  getProcessedEFax: async (orderId) => {
    try {
      const response = await apiService.get(`/efax/processed/${orderId}`);
      return response.data;
    } catch (error) {
      console.error(
        `Error getting processed eFax for order ${orderId}:`,
        error
      );
      return null;
    }
  },

  // Get recent eFaxes
  getRecentEFaxes: async (skip = 0, limit = 10) => {
    try {
      const response = await apiService.get("/efax/recent", {
        params: { skip, limit },
      });
      return response.data;
    } catch (error) {
      console.error("Error getting recent eFaxes:", error);
      return [];
    }
  },

  // Create manual order from eFax
  createManualOrder: async (orderData) => {
    try {
      const response = await apiService.post("/efax/manual-entry", orderData);
      return response.data;
    } catch (error) {
      console.error("Error creating manual order from eFax:", error);
      throw error;
    }
  },

  // Update order from eFax
  updateOrderFromEFax: async (orderId, updateData) => {
    try {
      const response = await apiService.put(
        `/orders/efax/${orderId}/update`,
        updateData
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating order ${orderId} from eFax:`, error);
      throw error;
    }
  },
};
